import store from "../../store";

/**
 * 灵犀事件埋点 lxBidTracker
 * @param {Object} opts {bid: String | 必传, type: String | 埋点类型,默认'moduleClick', customParam: Object | 业务参数}
 */
export const lxBidTracker = function (opts = {}){
  let bid = opts.bid;
  if (!bid || bid === "") {
    console.error('bid is necessary！');
    return;
  }
  let type = opts.type || 'moduleClick';
  const cid = opts.cid || '';
  const options = {};
  if (cid) {
    options.cid = cid;
  }
  let customParam = opts.customParam || {};
  let custom = {
    AppVersion: '',
    hotel_id: '',
    user_id: store.state.userInfo.userId,
    agency_id: store.state.userInfo.agencyId,
    ...customParam
  };
  let valLab = {
    custom: custom
  };
  window.LXAnalytics && window.LXAnalytics(type, bid, valLab, options);
};

/**
 * 灵犀页面埋点 lxCidTracker
 * @param {String} path 需要埋点的路由，获取cid
 */
export const lxCidTracker = function (path){
  let cid = path.meta && path.meta.cid;
  let valLab = {};
  if (vm.$store.state.userInfo.userId && vm.$store.state.userInfo.agencyId && cid) {
    valLab = {
      custom: {
        AppVersion: '',
        hotel_id: '',
        user_id: store.state.userInfo.userId,
        agency_id: store.state.userInfo.agencyId,
      }
    };
    window.LXAnalytics && window.LXAnalytics('pageView', valLab, {}, cid);
  }
};



// WEBPACK FOOTER //
// ./src/components/util/lxTracker.js